export const OVERLAPS = {
['24•English']:'N'
, ['1483•English']:'M', 
['3•Thai']:'S'
, ['297•Thai']:'N', 
['24•Hindi']:'N'
, ['1483•Hindi']:'M', 
['24•Brazilian Portuguese']:'N'
, ['1483•Brazilian Portuguese']:'M', 
['24•Spanish']:'N'
, ['1483•Spanish']:'M', 
['24•Turkish']:'N'
, ['1483•Turkish']:'M', 
['95•Traditional Chinese']:'N'
, ['1481•Traditional Chinese']:'M', 
['95•French']:'N'
, ['1481•French']:'M', 
['95•Indonesian']:'N'
, ['1481•Indonesian']:'M', 
['95•Turkish']:'N'
, ['1481•Turkish']:'M', 
['17•French']:'N'
, ['1308•French']:'M', 
['17•Indonesian']:'N'
, ['1308•Indonesian']:'M', 
['18•Japanese']:'N'
, ['205•Japanese']:'N'
};
export const WARNS = {
'ゴースト•Japanese' : ['*', 'WARNING: ゴースト could mean either Ghost (type) or Haunter (pokemon)! This page defaults to Ghost, please edit the output if you want Haunter','WARNING: ゴースト means both Ghost (type) and Haunter (pokemon) [Unknown Priority], so your output may be different than expected'], 
'VOL•French' : ['M', 'WARNING: Vol could mean either Flying (type) or Fly (move)! This page defaults to @Fly, please edit the output if you want @Flying','WARNING: Vol means both Flying (type) and Fly (move) [type taking priority], so your output may be different than expected'], 
'TERBANG•Indonesian' : ['M', 'WARNING: Terbang could mean either Flying (type) or Fly (move)! This page defaults to @Fly, please edit the output if you want @Flying','WARNING: Terbang means both Flying (type) and Fly (move) [type taking priority], so your output may be different than expected'], 
'PSYCHIC•English' : ['M', 'WARNING: Psychic could mean either Psychic (type) or Psychic (move)! This page defaults to @Psychic (Move), please edit the output if you want @Psychic (type)','WARNING: Psychic means both Psychic (type) and Psychic (move) [type taking priority], so your output may be different than expected'], 
'साइकक•Hindi' : ['M', 'WARNING: साइकक could mean either Psychic (type) or Psychic (move)! This page defaults to @Psychic (Move), please edit the output if you want @Psychic (type)','WARNING: साइकक means both Psychic (type) and Psychic (move) [type taking priority], so your output may be different than expected'], 
'PSÍQUICO•Brazilian Portuguese' : ['M', 'WARNING: Psíquico could mean either Psychic (type) or Psychic (move)! This page defaults to @Psychic (Move), please edit the output if you want @Psychic (type)','WARNING: Psíquico means both Psychic (type) and Psychic (move) [type taking priority], so your output may be different than expected'], 
'PSÍQUICO•Spanish' : ['M', 'WARNING: Psíquico could mean either Psychic (type) or Psychic (move)! This page defaults to @Psychic (Move), please edit the output if you want @Psychic (type)','WARNING: Psíquico means both Psychic (type) and Psychic (move) [type taking priority], so your output may be different than expected'], 
'PSIŞIK•Turkish' : ['M', 'WARNING: Psişik could mean either Psychic (type) or Psychic (move)! This page defaults to @Psychic (Move), please edit the output if you want @Psychic (type)','WARNING: Psişik means both Psychic (type) and Psychic (move) [type taking priority], so your output may be different than expected']
};
export const LOCALES = {
'English':'en',
'Brazilian Portuguese':'pt-BR',
'Chinese Traditional':'zh',
'French':'fr',
'German':'de',
'Hindi':'hi',
'Indonesian':'id',
'Italian':'it',
'Japanese':'ja',
'Korean':'ko',
'Russian':'ru',
'Spanish':'es',
'Thai':'th',
'Turkish':'tr',
'Spanish (Latin American)':'es-MX'
};
